import {Box, Loader, Text} from "@mantine/core";
import {useContext} from "react";
import {useTranslation} from "react-i18next";
import {GPTMetaContext} from "../MetaProvider";
import {ArtifactRenderer} from "../../artifacts";
import {resolveEmailFence} from "./selectedEmail";

export function EmailBlock({text}: {text: string}) {
    const meta = useContext(GPTMetaContext);
    const {t} = useTranslation();
    const resolution = resolveEmailFence(text, meta?.artifacts, !!meta?.isStreaming);
    if (resolution.status === "pending") return <Box my="sm" role="status"><Loader size="xs" /><Text size="sm">{t("chat.email.loading", {defaultValue: "Loading email draft"})}</Text></Box>;
    if (resolution.status === "invalid") return <Text my="sm" size="sm" c="dimmed" role="status">{t("chat.email.unavailable", {defaultValue: "The email draft could not be displayed."})}</Text>;
    return <Box my="sm"><ArtifactRenderer artifact={resolution.artifact} /></Box>;
}
